<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card class="rounded-card" :to="{ name: 'animal', params: { id: listing.id } }" tile>
        <v-img :src="image" :aspect-ratio="4/3" :contain="contain">
            <v-layout row wrap justify-end>
                <v-flex shrink>
                    <v-chip color="red" label text-color="white" class="ma-3" v-if="listing.is_adopted" small>{{ $t('animal_status_adopted') }}</v-chip>
                    <v-chip color="red" label text-color="white" class="ma-3" v-if="listing.is_reserved" small>{{ $t('animal_status_reserved') }}</v-chip>
                    <v-chip color="red" label text-color="white" class="ma-3" v-if="listing.is_new" small>{{ $t('animal_badge_new') }}</v-chip>
                </v-flex>
            </v-layout>
        </v-img>

        <v-card-title primary-title>
            <div>
                <h3 class="title mb-1">{{ listing.name }}</h3>
                <div class="subtitle-1 grey--text">{{ listing.gender.display_name }} / {{ listing.date_of_birth != null ? listing.date_of_birth.age_display_name : $t('animal_card_age_unknown') }} / {{ listing.size != null ? listing.size.display_name : $t('animal_card_size_unknown') }} </div>
            </div>
        </v-card-title>
    </v-card>
</template>
<script>
    export default {
        props: [ 'listing' ],
        computed: {
            image() {
                return this.listing.photos.length > 0 ? this.listing.photos[0].source.preview.url : require('../assets/pawprint.svg')
            },
            contain() {
                return this.listing.photos.length == 0
            }
        },
        components: {
        }
    }
</script>
<style>
    .rounded-card{
        border-radius: 4px;
    }
</style>